import { render, staticRenderFns } from "./PromotionMessage.vue?vue&type=template&id=4c65256a&"
import script from "./PromotionMessage.vue?vue&type=script&lang=js&"
export * from "./PromotionMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports